<template>
  <v-text-field
    :label="label"
    :disabled="disabled"
    :rules="rules"
    :type="showPassword ? 'text' : 'password'"
    variant="outlined"
    color="parimary"
    class="custom-password-field"
    v-bind="$attrs"
    @click:append-inner="showPassword = !showPassword"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'CustomPasswordField',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Password',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  emits: ['input', 'change'],
}
</script>

<style scoped>
.custom-password-field {
  font-size: 1rem;
  padding: 0px 0px !important;
  text-align: right;
}
</style>